export const reservedSlugs = [
	'login',
	'signup',
	'auth',
	'onboarding',
	'~',
	'no-workspace',
];
